var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "ui top fixed menu borderless" }, [
    _c(
      "button",
      {
        staticClass: "item",
        class: _vm.$style.transBtn,
        attrs: { "data-wd": "backBtn" },
        on: {
          click: function($event) {
            return _vm.$emit("back")
          }
        }
      },
      [_c("i", { staticClass: "chevron left icon" })]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "ui item", class: _vm.$style.inputItem }, [
      _c(
        "form",
        {
          class: _vm.$style.form,
          attrs: { role: "search", "data-wd": "inSearch" },
          on: {
            submit: function($event) {
              $event.preventDefault()
              return _vm.search.apply(null, arguments)
            }
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "ui transparent input",
              class: _vm.$style.inputCont
            },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.query,
                    expression: "query"
                  },
                  {
                    name: "focus",
                    rawName: "v-focus",
                    value: _vm.inputFocused,
                    expression: "inputFocused"
                  }
                ],
                attrs: { type: "search", placeholder: _vm.$t("placeholder") },
                domProps: { value: _vm.query },
                on: {
                  focus: _vm.focus,
                  blur: function($event) {
                    _vm.inputFocused = false
                  },
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.query = $event.target.value
                  }
                }
              })
            ]
          )
        ]
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "right menu" }, [
      _c(
        "button",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.isQueryEmpty,
              expression: "!isQueryEmpty"
            }
          ],
          staticClass: "item",
          class: _vm.$style.transBtn,
          on: { click: _vm.clearQuery }
        },
        [_c("i", { staticClass: "remove icon" })]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }